import { buildCsv } from './downloadOriginCsv';
import {
  DELIVERY_SHIPMENT_LEAD,
  DELIVERY_SHIPMENT_METRICS,
} from './downloadReportCatalog';

export { buildCsv };

export const deliveryCsvFileName = (from, to) => {
  const safePart = value => String(value || '').replace(/:/g, '-');
  return `delivery-shipments-${safePart(from)}-to-${safePart(to)}.csv`;
};

export const deliveryCsvLeadCells = (row = {}) =>
  DELIVERY_SHIPMENT_LEAD.map(column => row[column] || '');

export const deliveryCsvMetricCells = (metrics = {}) =>
  DELIVERY_SHIPMENT_METRICS.map(column => metrics[column] ?? 0);
